import { memo } from 'react';

import { DefaultDocumentTitleHead } from '~/components/v2/components/shared/seo/DefaultDocumentTitleHead';
import { RegisteredDocumentTitleHead } from '~/components/v2/components/shared/seo/RegisteredDocumentTitleHead';

/**
 * The only client-side `<title>` for pages that register through `useDocumentTitle`. next/head keeps the
 * most recently rendered `<title>`, so a second emitter would overwrite this on re-render.
 * Mount once at the top of `_app`, before any page renders a `<Head>`.
 */
export const DocumentTitleHead = memo(() => (
  <>
    <DefaultDocumentTitleHead />
    <RegisteredDocumentTitleHead />
  </>
));

DocumentTitleHead.displayName = 'DocumentTitleHead';
